//import Applications from "./Applications";
import Auth from "./Auth/index";
import Logs from "./Logs/index";
import Phone from "./Phone/index";
import User from "./User/index";
const WorkanoSDK = {
  Auth: Auth,
  Phone: Phone,
  User: User,
  Logs: Logs,
};
export default WorkanoSDK;
